import { useContext } from "react";
import { VerifyContext } from "../../app/VerifyContext";
import AdminDashboard from "./ui/AdminDashboard";
import TmDashboard from "./ui/TmDashboard";
import DueTodayCard from "./ui/DueTodayCard";
import MeetingsOverdueCard from "./ui/MeetingsOverdueCard";

const DashboardBody = () => {
  const { superAdmin, isTechnicalManager, canAccessCrm, canAccessMeetings } = useContext(VerifyContext);

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground font-inter">Dashboard</h1>
        <p className="text-sm text-muted-foreground font-inter mt-1">
          {superAdmin
            ? "Job Board activity across your organization"
            : isTechnicalManager
            ? "Your Job Board activity at a glance"
            : "Overview of your organization at a glance"}
        </p>
      </div>

      {superAdmin ? (
        <AdminDashboard />
      ) : (
        <div className="space-y-8">
          {isTechnicalManager && <TmDashboard />}
          {/* anyone with the CRM permission gets the LinkedIn card (an employee used to see a dashboard only as a Technical Manager) */}
          {canAccessCrm && <DueTodayCard />}
          {canAccessMeetings && <MeetingsOverdueCard />}
          {!isTechnicalManager && !canAccessCrm && !canAccessMeetings && (
            <p className="text-sm text-muted-foreground font-inter">Nothing to show here yet.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default DashboardBody;
